document.addEventListener('DOMContentLoaded', function() {
  function hideSingleOptionFilters() {
    const filterGroups = document.querySelectorAll('.filter-group');

    filterGroups.forEach(group => {
      const filterType = group.querySelector('.filter__price') ? 'price_range' : 'list';
      
      // Skip price_range filters
      if (filterType === 'price_range') {
        return;
      }

      // For list-type filters, count the number of visible options
      const visibleOptions = group.querySelectorAll('.sidebar__item:not(.hidden):not(.link--disable)').length;
      
      if (visibleOptions <= 1) {
        group.style.display = 'none';
        console.log(`Hiding filter: ${group.querySelector('.filter-group__heading span').textContent.trim()} (only ${visibleOptions} option)`);
      }
    });
  }

  // Run the function when the page loads
  hideSingleOptionFilters();

  // If you're using AJAX to update filters, you might want to run this function after each update
  // For example:
  document.addEventListener('collection:updated', hideSingleOptionFilters);
});
